<template>
  <div class="relative mt-1 w-full" id="multiselect-container">
    <button
      :disabled="options.length <= 0"
      type="button"
      aria-haspopup="listbox"
      @click="toggleOpen"
      class="cursor-pointer relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
    >
      <span class="flex items-center">
        <span v-if="selected.length > 0" class="block truncate flex flex-wrap">
          <div
            v-for="(option, index) in sortedSelected"
            :key="index"
            class="px-3 py-1 flex items-center bg-gray-700 text-white font-bold m-0.5 rounded"
            @click.stop="handleUpdate(option)"
          >
            {{ option[label] }}
            <i class="fas fa-times-circle ml-2 cursor-pointer"></i>
          </div>
        </span>
        <span v-else class="block truncate">Select values</span>
      </span>
      <span
        class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
      >
        <IconSelector />
      </span>
    </button>

    <div
      v-if="expanded"
      v-click-outside="handleClose"
      class="z-10 absolute mt-1 w-full rounded-md bg-white shadow-lg"
    >
      <ul
        tabindex="-1"
        role="listbox"
        aria-labelledby="listbox-label"
        aria-activedescendant="listbox-item-3"
        class="max-h-56 py-1 text-base text-sm rounded-md ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none"
      >
        <li>
          <SearchBar
            placeholder="Search by product name"
            v-on:handleInput="handleInput"
          />
        </li>
        <li
          v-for="(option, index) in this.options"
          :key="index"
          id="listbox-item-0"
          role="option"
          :class="`cursor-pointer text-gray-900 select-none relative py-2 pl-3 pr-9 hover:bg-gray-100 ${
            isSelected(option) ? 'bg-gray-100' : ''
          }`"
          @click.stop="handleUpdate(option)"
        >
          <div class="flex items-center">
            <span class="ml-3 block font-normal text-sm truncate">
              {{ option[label] }}
            </span>
          </div>
          <span
            v-if="isSelected(option)"
            class="absolute inset-y-0 right-0 flex items-center pr-4"
          >
            <IconSolidCheck />
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from "underscore";
import IconSelector from "@/assets/icons/IconSelector";
import IconSolidCheck from "@/assets/icons/IconSolidCheck";
import SearchBar from "@/components/Shared/Input/SearchBar";

export default {
  name: "SearchAndMultiSelect",
  components: {
    IconSelector,
    IconSolidCheck,
    SearchBar
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    handleUpdate: {
      type: Function,
      required: true
    },
    selected: {
      type: Array,
      required: false
    },
    handleInput: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      expanded: false
    };
  },
  computed: {
    sortedSelected() {
      return _.sortBy(this.selected, (s) => s[this.label]);
    }
  },
  directives: {
    "click-outside": {
      mounted(el, { value: closeFunction }) {
        window.addEventListener("click", closeFunction);
      },
      unmounted(el, { value: closeFunction }) {
        window.removeEventListener("click", closeFunction);
      }
    }
  },
  methods: {
    toggleOpen() {
      this.expanded = !this.expanded;
      setTimeout(() => {
        this.isOpen = true;
      }, 200);
    },
    close() {
      this.isOpen = false;
      this.expanded = false;
    },
    handleClose() {
      if (this.isOpen) {
        if (
          !document
            .getElementById("multiselect-container")
            .contains(window.event.target)
        ) {
          this.close();
        }
      }
    },
    isSelected(option) {
      return (
        this.selected.filter((p) => p[this.label] === option[this.label])
          .length > 0
      );
    }
  }
};
</script>
